import { convertAmountToCurrency, getRequiredMargin } from "@/utils/trade";
import { formatAmount } from "@/utils/format";
import { ISymbolInfo } from "@/services/trade/symbols";

type CalculateMarginsParams = {
    lotSize: string | number;
    accountCurrency: string;
    symbolInfo: ISymbolInfo;
    bid: number;
    ask: number;
    leverage: number;
    accountLeverage: number;
    isMTR: boolean;
    symbols: string[];
    mainCurrency: string;
};

type CalculateMarginsResult = {
    requiredBuyMargin: number;
    requiredSellMargin: number;
    requiredBuyMarginDisplayValue: string;
    requiredSellMarginDisplayValue: string;
    marginDisplayValueInSymbolCurrency: string;
};


export function calculateMargins({
    lotSize,
    accountCurrency,
    symbolInfo,
    bid,
    ask,
    leverage,
    accountLeverage,
    isMTR,
    symbols,
    mainCurrency,
}: CalculateMarginsParams): CalculateMarginsResult {
    const rawBuy = getRequiredMargin(
        accountCurrency,
        symbolInfo?.id,
        lotSize,
        symbolInfo?.contractSize,
        ask,
        symbolInfo?.ex?.profitCalculationMode,
        symbolInfo?.ex?.marginCalculationMode,
        accountLeverage,
        leverage,
        symbolInfo?.percentage,
        symbolInfo?.group?.isFixedLeverage
    );

    const rawSell = getRequiredMargin(
        accountCurrency,
        symbolInfo?.id,
        lotSize,
        symbolInfo?.contractSize,
        bid,
        symbolInfo?.ex?.profitCalculationMode,
        symbolInfo?.ex?.marginCalculationMode,
        accountLeverage,
        leverage,
        symbolInfo?.percentage,
        symbolInfo?.group?.isFixedLeverage
    );

    const convertedBuy = convertAmountToCurrency({
        amount: rawBuy,
        fromCurrency: isMTR ? mainCurrency : symbolInfo?.currency,
        toCurrency: accountCurrency,
        symbols,
        conversionPriceType: "Ask",
    });

    const convertedSell = convertAmountToCurrency({
        amount: rawSell,
        fromCurrency: isMTR ? mainCurrency : symbolInfo?.currency,
        toCurrency: accountCurrency,
        symbols,
        conversionPriceType: "Bid",
    });

    return {
        requiredBuyMargin: convertedBuy,
        requiredSellMargin: convertedSell,
        requiredBuyMarginDisplayValue: formatAmount(convertedBuy, accountCurrency),
        requiredSellMarginDisplayValue: formatAmount(convertedSell, accountCurrency),
        marginDisplayValueInSymbolCurrency: formatAmount(
            rawSell,
            isMTR ? mainCurrency : symbolInfo?.currency,
            2
        )
    };
}